import VueRouter, { RouteConfig } from 'vue-router'

export const PrizeSolicitationRoute: RouteConfig = {
  path: '/activity/prize-solicitation',
  name: 'activity_prize_solicitation',
  component: () => import('../activity/prize-solicitation/Index.vue'),
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '奖品征集',
  },
}

export default [PrizeSolicitationRoute]
